import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ArmSessionService} from '../../services/common/arm-session/arm-session.service';
import {SessionService} from 'ac-infra';
import {SingleSignonApiService} from '../../services/api/single-signon/single-signon-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(private router: Router,
              private sessionService: SessionService,
              private armSessionService: ArmSessionService,
              private singleSignOnApiService: SingleSignonApiService) {
  }

  canActivate(route, state): any {
    const isLoginUrl = route.routeConfig.path === 'login';
    const params = route.queryParams;

    if (params && params.authToken) {
      return this.singleSignOn(params.authToken);
    } else if (!this.sessionService.activeSession && !isLoginUrl) {
      this.router.navigateByUrl('login');
      return false;
    } else if (this.sessionService.activeSession && !this.sessionService.activeSession.locked && isLoginUrl) {
      this.router.navigateByUrl('');
      return false;
    } else {
      return true;
    }
  }

  private singleSignOn(token): any {
    return this.singleSignOnApiService.authenticateUserByToken(token).then((userDetails) => {
      this.sessionService.startSession(this.armSessionService.generateSessionObj(userDetails));
      this.router.navigateByUrl('');
      return false;
    }).catch(error => {
      this.router.navigateByUrl('login');
      return false;
    });
  }
}
